export default __webpack_public_path__ + "static/media/Step2_giglinked-svg.0bdf5956.png";